<template>
  <div>
    <!-- 潜在客户列表 -->
    <div>
      <!-- 行业Tab切换 -->
      <div class="industry-tabs" style="margin-bottom: 15px;">
      <el-radio-group v-model="selectedIndustryTab" @change="handleIndustryTabChange">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button
          v-for="item in industrys"
          :key="item.code"
          :label="item.code"
          :class="'industry-tab-' + item.name"
        >
          {{ item.name }}
        </el-radio-button>
      </el-radio-group>
    </div>

    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <!-- 搜索 -->
      <div style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap;">
        <el-input
          style="width: 150px"
          prefix-icon="el-icon-edit"
          v-model="custName"
          size="mini"
          placeholder="客户名称"
          clearable
          @keydown.enter.native="onSearch"
        ></el-input>
        <el-select
          v-if="isSales"
          v-model="ownerType"
          placeholder="客户归属"
          style="width: 120px"
          size="mini"
          clearable
          @change="onSearch"
        >
          <el-option label="自己" :value="0"></el-option>
          <el-option label="他人" :value="1"></el-option>
        </el-select>
        <el-select
          v-model="claimStatus"
          placeholder="状态"
          style="width: 120px"
          size="mini"
          clearable
          @change="onSearch"
        >
          <el-option label="未认领" :value="0"></el-option>
          <el-option label="已认领" :value="1"></el-option>
          <!-- <el-option label="审批中" :value="2"></el-option> -->
          <el-option label="已走访" :value="3"></el-option>
          <!-- <el-option label="审批驳回" :value="4"></el-option> -->
        </el-select>
        <el-select
          v-model="province"
          placeholder="省份"
          style="width: 120px"
          size="mini"
          clearable
          @change="provinceChangeSearch"
        >
          <el-option
            v-for="item in provinces"
            :key="item.provinceCode"
            :label="item.provinceName"
            :value="item.provinceCode"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="city"
          placeholder="地市"
          style="width: 120px"
          size="mini"
          clearable
          :disabled="!province"
          @change="onSearch"
        >
          <el-option
            v-for="item in citys"
            :key="item.cityCode"
            :label="item.cityName"
            :value="item.cityCode"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="custManagerName"
          placeholder="认领销售"
          style="width: 120px"
          size="mini"
          clearable
          @change="onSearch"
        >
          <el-option
            v-for="item in managers"
            :key="item.id"
            :label="item.uname"
            :value="item.uname"
          >
          </el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="onSearch" size="mini">搜索</el-button>
      </div>
      <!-- 右边工具  添加新客户  -->
      <div>
        <el-button
          type="warning"
          icon="el-icon-upload"
          @click="importDialogVisible = true"
          size="mini"
          style="margin-right: 10px"
          v-if="isCustManager"
          >导入潜在客户</el-button
        >
        <el-button
          type="info"
          icon="el-icon-download"
          @click="exportToExcel"
          size="mini"
          style="margin-right: 10px"
          v-if="isCustManager"
        >
          导出数据
        </el-button>
        <el-button
          type="success"
          icon="el-icon-user"
          @click="addCust"
          size="mini"
          v-if="isCustManager"
          >添加潜在客户</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <div style="margin-top: 20px">
      <el-table
        :data="queryData"
        stripe
        border
        :cell-style="{ padding: '5px 0' }"
        fit
        id="potentialTable"
        size="mini"
        v-loading="loading"
        :row-style="{ height: '60px' }"
        height="calc(100vh - 280px)"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :header-cell-style="{
          background: '#eef1f6',
          color: '#606266',
          borderColor: 'white',
        }"
        style="width: 100%"
      >
        <el-table-column
          prop="custName"
          label="客户名称"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.custName || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="industryName"
          label="所属行业"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
             {{ scope.row.industryName || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="provinceName"
          label="省份"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.provinceName || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="cityName"
          label="地市"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.cityName || '-' }}
          </template>
        </el-table-column>
        
        <el-table-column
          prop="custManagerName"
          label="认领销售"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.custManagerName || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="claimReason"
          label="认领理由"
          align="center"
          min-width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.claimReason || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="认领时间"
          align="center"
          min-width="150"
        
        :formatter="dateTimeTwoLine"
        class-name="cell-two-line"
        >
          <template slot-scope="scope">
            {{ scope.row.claimTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="remarks"
          label="备注"
          align="center"
          min-width="180"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.remarks || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.claimStatus == 0">
              <el-tag type="info" size="mini">未认领</el-tag>
            </template>
            <template v-if="scope.row.claimStatus == 1">
              <el-tag type="primary" size="mini">已认领</el-tag>
            </template>
            <!-- <template v-if="scope.row.claimStatus == 2">
              <el-tag type="warning" size="mini">审批中</el-tag>
            </template> -->
            <template v-if="scope.row.claimStatus == 3">
              <el-tag type="success" size="mini">已走访</el-tag>
            </template>
            <!-- <template v-if="scope.row.claimStatus == 4">
              <el-tag type="danger" size="mini">审批驳回</el-tag>
            </template> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <div v-if="isCustManager">
              <el-button
                type="text"
                size="mini"
                icon="el-icon-edit"
                @click="editCust(scope.row)"
                style="color: #409eff; padding: 0 5px;"
              >
                修改
              </el-button>
              <el-button
                type="text"
                size="mini"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                style="color: #f56c6c; padding: 0 5px;"
              >
                删除
              </el-button>
            </div>
            <div v-else-if="!scope.row.custManagerId">
              <el-button
                type="success"
                size="mini"
                icon="el-icon-s-custom"
                @click="claimCust(scope.row)"
              >
                认领客户
              </el-button>
            </div>
            <div v-else-if="scope.row.custManagerId == currentUserId && (scope.row.claimStatus == 1 || scope.row.claimStatus == 3 || scope.row.claimStatus == 4)">
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-error"
                @click="openUnbindDialog(scope.row)"
              >
                释放客户
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="display: flex; justify-content: flex-end; margin-top: 5px">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-sizes="[10, 20, 50, 100, 1000]"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page">
        </el-pagination>
      </div>
    </div>
    </div>

    <!-- 添加潜在客户弹出框 -->
    <el-dialog
      :title="isEditMode ? '编辑潜在客户' : '添加潜在客户'"
      :visible.sync="dialogVisible"
      width="700px"
      top="15%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="potential-dialog"
    >
      <el-form
        ref="inputCustForm"
        :model="inputCustObj"
        :rules="rules"
        label-width="90px"
        style="padding: 15px 0;"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客户名称" prop="custName">
              <el-input
                v-model="inputCustObj.custName"
                placeholder="请输入客户名称"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属行业" prop="industry">
              <el-select
                v-model="inputCustObj.industry"
                placeholder="请选择行业"
                size="small"
                style="width: 230px"
              >
                <el-option
                  v-for="item in industrys"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code * 1"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属省份" prop="province">
              <el-select
                v-model="inputCustObj.province"
                placeholder="请选择省份"
                size="small"
                @change="provinceChange"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in provinces"
                  :key="item.provinceCode"
                  :label="item.provinceName"
                  :value="item.provinceCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属城市">
              <el-select
                v-model="inputCustObj.city"
                placeholder="请选择城市"
                size="small"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in citys"
                  :key="item.cityCode"
                  :label="item.cityName"
                  :value="item.cityCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="inputCustObj.remarks"
                placeholder="请输入备注信息（选填）"
                size="small"
                :rows="3"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="doChance">取消</el-button>
        <el-button type="primary" size="small" @click="doAddRecord">{{ isEditMode ? '确认修改' : '确认添加' }}</el-button>
      </div>
    </el-dialog>

    <!-- 导入潜在客户弹窗 -->
    <el-dialog
      title="导入潜在客户"
      :visible.sync="importDialogVisible"
      width="600px"
      top="15%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="margin-bottom: 20px">
        <el-button
          type="text"
          icon="el-icon-download"
          @click="downloadImportTemplate"
        >
          下载导入模板
        </el-button>
      </div>
      <el-upload
        ref="upload"
        class="upload-demo"
        drag
        action="#"
        :on-change="handleFileChange"
        :on-exceed="handleFileExceed"
        :auto-upload="false"
        :limit="1"
        accept=".xlsx,.xls"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传 xlsx/xls 文件</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="importDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="handleImport">确认导入</el-button>
      </div>
    </el-dialog>

    <!-- 地图搜索认领客户弹窗 -->
    <el-dialog
      title="地图搜索"
      :visible.sync="bindDialogVisible"
      width="90%"
      top="3%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="bind-cust-dialog"
    >
      <div class="bind-search-bar">
        <span class="bind-hint">输入客户名称，搜索并选择地址添加客户</span>
      </div>
      <div class="bind-search-row">
        <el-input
          v-model="searchKeyword"
          placeholder="请输入要搜索的位置"
          prefix-icon="el-icon-search"
          size="small"
          style="width: 400px"
          @keyup.enter.native="searchPlace"
        >
        </el-input>
        <el-button type="primary" size="small" @click="searchPlace" style="margin-left: 10px">
          搜索
        </el-button>
      </div>

      <div class="bind-main">
        <!-- 左侧搜索结果列表 -->
        <div class="bind-results">
          <div class="bind-results-header">搜索结果</div>
          <div class="bind-results-list">
            <div
              v-for="(item, index) in searchResults"
              :key="index"
              :class="['bind-result-item', { 'active': selectedIndex === index }]"
              @click="selectResult(item, index)"
            >
              <div class="result-name">{{ item.name }}</div>
              <div class="result-address">{{ item.address }}</div>
              <div class="result-location">
                <i class="el-icon-location-outline"></i>
                <span>{{ item.district }} {{ item.businessArea }}</span>
              </div>
            </div>
            <div v-if="searchResults.length === 0 && hasSearched" class="empty-tip">
              未找到相关结果
            </div>
          </div>
        </div>

        <!-- 右侧地图 -->
        <div class="bind-map-area">
          <div class="map-info-bar">位置信息</div>
          <div id="bindCustMap" class="amap-container">
            <div v-if="mapLoading" class="map-loading">
              <i class="el-icon-loading"></i>
              <span>地图加载中...</span>
            </div>
          </div>
          <div v-if="selectedResult" class="selected-info">
            <div class="selected-name">{{ selectedResult.name }}</div>
            <div class="selected-address">{{ selectedResult.address }}</div>
            <div class="selected-coords">
              经度: {{ selectedResult.longitude }} &nbsp;&nbsp; 纬度: {{ selectedResult.latitude }}
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="bindDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          size="small"
          :disabled="!selectedResult"
          @click="confirmBind"
        >
          <i class="el-icon-link"></i> 认领客户
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="客户位置"
      :visible.sync="viewLocationDialogVisible"
      width="800px"
      class="view-location-dialog"
    >
      <div v-if="viewLocationData" class="location-info">
        <div class="location-name">{{ viewLocationData.custName }}</div>
        <div class="location-address">{{ viewLocationData.address || '暂无地址' }}</div>
        <div class="location-coords">
          经度: {{ viewLocationData.longitude }} &nbsp;&nbsp; 纬度: {{ viewLocationData.latitude }}
        </div>
      </div>
      <div id="viewLocationMap" class="view-map-container">
        <div v-if="viewMapLoading" class="map-loading">
          <i class="el-icon-loading"></i>
          <span>地图加载中...</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewLocationDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 认领客户弹窗 -->
    <el-dialog
      title="认领客户"
      :visible.sync="claimDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      @close="resetClaimForm"
    >
      <el-form ref="claimForm" :model="claimData" :rules="claimRules" label-width="92px">
        <el-form-item label="客户名称">
          <el-input v-model="claimData.claimCustName" disabled></el-input>
        </el-form-item>
        <el-form-item label="认领理由" prop="claimReason" required>
          <el-input
            type="textarea"
            v-model="claimData.claimReason"
            placeholder="请输入认领理由"
            :rows="3"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="claimDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="submitClaim" :loading="claimSubmitting">确 认 认 领</el-button>
      </div>
    </el-dialog>

    <!-- 相似客户提示弹窗 -->
    <el-dialog
      title="相似客户提示"
      :visible.sync="similarDialogVisible"
      width="1200px"
      top="15%"
      :close-on-click-modal="false"
    >
      <p style="margin-bottom: 10px; color: #E6A23C;">
        <i class="el-icon-warning"></i>
        客户名称: {{ currentInputCustName }}，该名称与以下客户类似，请确认是否有重复客户？
      </p>
      <el-table :data="similarCustomerList" border size="mini" max-height="350">
        <el-table-column prop="name" label="客户名称" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="相似度" width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.score >= 0.8" type="danger" size="mini">很相似</el-tag>
            <el-tag v-else-if="scope.row.score >= 0.5" type="warning" size="mini">部分相似</el-tag>
            <el-tag type="success" v-else>略微相似</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="industry" label="所属行业" align="center"></el-table-column>
        <el-table-column prop="city" label="所在城市" width="100" align="center"></el-table-column>
        <el-table-column prop="address" label="地址" width="300" align="center"></el-table-column>
        <el-table-column label="认领状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.claimStatus === 1" type="success" size="mini">已认领</el-tag>
            <el-tag v-else type="info" size="mini">未认领</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="custManagerName" label="认领人" width="100" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="similarDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="confirmAddAfterSimilarCheck">继 续 添 加</el-button>
      </div>
    </el-dialog>

    <!-- 导入结果详情弹窗 -->
    <el-dialog
      title="导入结果详情"
      :visible.sync="importResultDialogVisible"
      width="1200px"
      top="10%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="import-result-dialog"
    >
      <!-- 统计摘要 -->
      <div class="import-result-summary" v-if="importResultData">
        <span class="summary-success">
          <i class="el-icon-circle-check"></i> 导入成功 <strong>{{ importResultData.successCount || 0 }}</strong> 
        </span>
        <span class="summary-fail" v-if="(importResultData.errorCount || 0) + (importResultData.fuzzyCount || 0) + (importResultData.skipCount || 0) > 0">
          <i class="el-icon-warning"></i> 导入失败 <strong>{{ (importResultData.errorCount || 0) + (importResultData.fuzzyCount || 0) + (importResultData.skipCount || 0) }}</strong> 
        </span>
      </div>

      <!-- Tabs 表格区域 -->
      <el-tabs v-model="importResultActiveTab" v-if="importResultData">
        <!-- 成功数据 Tab -->
        <el-tab-pane :label="'导入成功 ' + (importResultData.successCount || 0)" name="success" v-if="importResultData.successCount > 0">
          <el-table
            :data="importResultData.successDetails || []"
            border
            size="mini"
            max-height="400"
            style="width: 100%"
          >
            <el-table-column prop="row" label="行号" width="80" align="center"></el-table-column>
            <el-table-column prop="custName" label="客户名称" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="industryName" label="所属行业" width="120" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- 错误数据 Tab -->
        <el-tab-pane :label="'错误数据 ' + (importResultData.errorCount || 0)" name="error" v-if="importResultData.errorCount > 0">
          <el-table
            :data="importResultData.errorDetails || []"
            border
            size="mini"
            max-height="400"
            style="width: 100%"
          >
            <el-table-column prop="row" label="行号" width="80" align="center"></el-table-column>
            <el-table-column prop="custName" label="客户名称" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="industryName" label="所属行业" width="120" align="center"></el-table-column>
            <el-table-column prop="reason" label="错误原因" min-width="250" show-overflow-tooltip></el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- 相似数据 Tab -->
        <el-tab-pane :label="'相似数据 ' + (importResultData.fuzzyCount || 0)" name="fuzzy" v-if="importResultData.fuzzyCount > 0">
          <el-table
            :data="importResultData.fuzzyDetails || []"
            border
            size="mini"
            max-height="400"
            style="width: 100%"
          >
            <el-table-column prop="row" label="行号" width="80" align="center"></el-table-column>
            <el-table-column prop="custName" label="客户名称" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="industryName" label="所属行业" width="120" align="center"></el-table-column>
            <el-table-column prop="reason" label="原因" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="confirmFuzzyImport(scope.row)">查看相似客户</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- 已存在数据 Tab -->
        <el-tab-pane :label="'异常数据 ' + (importResultData.skipCount || 0)" name="skip" v-if="importResultData.skipCount > 0">
          <el-table
            :data="importResultData.skipDetails || []"
            border
            size="mini"
            max-height="400"
            style="width: 100%"
          >
            <el-table-column prop="row" label="行号" width="80" align="center"></el-table-column>
            <el-table-column prop="custName" label="客户名称" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="industryName" label="所属行业" width="110" align="center"></el-table-column>
            <el-table-column prop="reason" label="原因" min-width="220" show-overflow-tooltip></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="importResultDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 相似客户确认导入弹窗 -->
    <el-dialog
      title="查看相似客户"
      :visible.sync="fuzzyDetailDialogVisible"
      width="900px"
      top="10%"
      :close-on-click-modal="false"
    >
      <el-alert
        title="数据库已有相似客户，请确认无误之后再操作！"
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom: 14px;"
      ></el-alert>
      <p style="margin-bottom: 10px; color: #606266; font-size: 13px;">
        行号：<strong>{{ fuzzyDetailRow.row }}</strong> &nbsp;&nbsp;
        客户名称：<strong>{{ fuzzyDetailRow.custName }}</strong>
        <span v-if="fuzzyDetailRow.industryName"> &nbsp;&nbsp; 所属行业：<strong>{{ fuzzyDetailRow.industryName }}</strong></span>
        <span v-if="fuzzyDetailMatches.length"> &nbsp;&nbsp;（共 {{ fuzzyDetailMatches.length }} 条相似记录）</span>
      </p>
      <el-table
        :data="fuzzyDetailMatches"
        border
        size="mini"
        max-height="350"
        style="width: 100%"
      >
        <el-table-column prop="custName" label="客户名称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="industryName" label="所属行业" width="100" align="center"></el-table-column>
        <el-table-column label="省市" width="140" align="center">
          <template slot-scope="scope">
            {{ [scope.row.provinceName, scope.row.cityName].filter(Boolean).join(' / ') || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="地址" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="custManagerName" label="认领人" width="100" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column label="操作" width="110" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="viewFullDetail(scope.row)">查看完整详情</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="fuzzyDetailDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="fuzzyImportLoading" @click="doFuzzyImport">确认无误并导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { postProvinces, postCitys } from "../../api/SlmsData/Supplier";
import { listPotentialCust, addPotentialCust, claimPotentialCust, importPotentialCustBatch, bindPotentialCust, updatePotentialCust, deletePotentialCust, releasePotentialCust, fuzzySearch } from "../../api/cust/index";
import { getIndustryList, getSalesList } from "../../api/common";
import FileSaver from "file-saver";
import XLSXStyle from "xlsx-style";
import XLSX from "xlsx";
export default {
  name: "CustPotential",
  data() {
    return {
      ownerType: null,
      claimDialogVisible: false,
      claimSubmitting: false,
      claimCustId: null,
      claimData: {
        claimCustName: '',
        claimReason: '',
      },
      claimRules: {
        claimReason: [
          { required: true, message: '请输入认领理由' },
        ],
      },
      similarDialogVisible: false,
      similarCustomerList: [],
      currentInputCustName: '',
      queryData: [],
      showAdvanceSearchVisible: false,
      industrys: [],
      selectedIndustryTab: '',
      provinces: [],
      citys: [],
      custName: "",
      isAdmin: sessionStorage.getItem("userName") === "admin",
      isCustManager: sessionStorage.getItem("userName") === "xiaoszj",
      isSales: sessionStorage.getItem("userRoleId") === "2",
      currentUserId: sessionStorage.getItem("uid"),
      industry: null,
      province: null,
      city: null,
      claimStatus: null,
      custManagerName: null,
      managers: [],
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      dialogVisible: false,
      importDialogVisible: false,
      importResultDialogVisible: false,
      importResultData: {},
      importResultActiveTab: 'error',
      fuzzyDetailDialogVisible: false,
      fuzzyDetailRow: {},
      fuzzyDetailMatches: [],
      fuzzyImportLoading: false,
      isEditMode: false,
      editingCustId: null,
      importFileList: [],
      importData: [],
      bindDialogVisible: false,
      mapLoading: true,
      searchKeyword: "",
      searchResults: [],
      selectedResult: null,
      selectedIndex: -1,
      hasSearched: false,
      mapInstance: null,
      markerInstance: null,
      bindRowData: null,
      inputCustObj: {
        id: null,
        custName: "",
        province: "",
        city: "",
        industry: null,
        remarks: "",
      },
      viewLocationDialogVisible: false,
      viewLocationData: null,
      viewMapLoading: true,
      viewMapInstance: null,
      viewMarkerInstance: null,
      rules: {
        custName: [
          {
            required: true,
            message: "请输入客户名称",
            trigger: "blur",
          },
        ],
        industry: [
          {
            required: true,
            message: "请选择所属行业",
            trigger: "blur",
          },
        ],
      },
    };
  },
  async created() {
    await this.initDim();
    const queryClaimStatus = this.$route.query.claimStatus
    if (queryClaimStatus !== undefined) {
      this.claimStatus = Number(queryClaimStatus)
    }
    const queryIndustryName = this.$route.query.industryName
    if (queryIndustryName) {
      const match = this.industrys.find(item => item.name === queryIndustryName)
      if (match) {
        this.selectedIndustryTab = match.code
      }
    }
    const querySalesName = this.$route.query.salesName
    if (querySalesName) {
      this.custManagerName = querySalesName
    }
    const queryCustName = this.$route.query.custName
    if (queryCustName) {
      this.custName = queryCustName
    }
    this.$nextTick(() => {
      this.initData();
    });
  },
  methods: {
    onSearch() {
      this.page = 1;
      this.initData();
    },
    getIndustryClass(industryName) {
      const industryMap = {
        '企业': 'industry-enterprise',
        '政府': 'industry-government',
        '教育': 'industry-education',
        '金融': 'industry-finance',
        '医疗': 'industry-medical',
        '个人': 'industry-personal',
        '合作商': 'industry-partner',

      };
      return industryMap[industryName] || '';
    },
    clearAdvancedSearch() {
      this.custName = "";
      this.industry = null;
      this.province = null;
      this.city = null;
      this.claimStatus = null;
      this.custManagerName = null;
      this.citys = [];
      this.initData();
    },
    // 下载导入模板
    downloadImportTemplate() {
      const tHeader = ["客户名称", "所属行业"];
      const list = [
        ["示例客户1", "企业"],
        ["示例客户2", "政府"],
        ["示例客户3", "教育"],
        ["示例客户4", "金融"],
        ["示例客户5", "医疗"],
        ["示例客户6", "其他"]
      ];
      const ws = XLSX.utils.aoa_to_sheet([tHeader, ...list]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "潜在客户导入模板");

      const defaultStyle = {
        alignment: {
          horizontal: "center",
          vertical: "center",
          wrapText: true,
        },
        font: {
          sz: 12,
          name: "宋体",
        },
        border: {
          top: { style: "thin", color: { auto: 1 } },
          left: { style: "thin", color: { auto: 1 } },
          right: { style: "thin", color: { auto: 1 } },
          bottom: { style: "thin", color: { auto: 1 } },
        },
      };

      const headerStyle = {
        ...defaultStyle,
        font: { ...defaultStyle.font, bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "2D529F" } },
      };

      const cellStyle = {
        ...defaultStyle,
        font: { ...defaultStyle.font, bold: false },
      };

      ws["!cols"] = [
        { wpx: 150 },
        { wpx: 120 },
        { wpx: 120 },
        { wpx: 120 }
      ];

      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellAddress]) continue;
          ws[cellAddress].s = R === 0 ? headerStyle : cellStyle;
        }
      }

      const wbout = XLSXStyle.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "buffer",
      });
      FileSaver.saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "潜在客户导入模板.xlsx"
      );
    },
    // 文件选择处理
    handleFileChange(file) {
      this.importFileList = [file];
    },
    handleFileExceed() {
      this.$message.warning("只能上传一个文件");
    },
    // 点击导入按钮，打开确认弹窗
    confirmFuzzyImport(row) {
      this.fuzzyDetailRow = row;
      this.fuzzyDetailMatches = (row.matches || []).map(m => m.cust || m);
      this.fuzzyDetailDialogVisible = true;
    },
    // 查看完整详情：关闭弹窗，将客户名称代入搜索框并查询
    viewFullDetail(row) {
      this.fuzzyDetailDialogVisible = false;
      this.importResultDialogVisible = false;
      this.custName = row.custName || '';
      this.$nextTick(() => {
        this.initData();
      });
    },
    // 确认导入相似客户
    async doFuzzyImport() {
      const row = this.fuzzyDetailRow;
      // 根据 industryName 映射出 industry code
      let industry = row.industry;
      if (!industry && row.industryName) {
        const found = (this.industrys || []).find(item => item.name === row.industryName);
        if (found) {
          industry = found.code * 1;
        }
      }
      const params = {
        custName: row.custName,
        industry: industry,
        province: row.province,
        city: row.city,
        remarks: row.remarks || '',
      };
      this.fuzzyImportLoading = true;
      try {
        const resp = await addPotentialCust(params);
        if (resp && resp.code === 200) {
          this.$message.success('导入成功');
          this.fuzzyDetailDialogVisible = false;
          // 从相似列表中移除已导入的行，并添加到成功列表中
          const fuzzyDetails = this.importResultData.fuzzyDetails || [];
          const idx = fuzzyDetails.findIndex(item => item.row === row.row);
          if (idx > -1) {
            fuzzyDetails.splice(idx, 1);
            this.importResultData.fuzzyCount = (this.importResultData.fuzzyCount || 0) - 1;
            this.importResultData.successCount = (this.importResultData.successCount || 0) + 1;
            // 将确认导入的数据加入成功列表
            if (!this.importResultData.successDetails) {
              this.importResultData.successDetails = [];
            }
            this.importResultData.successDetails.push({
              row: row.row,
              custName: row.custName,
              industryName: row.industryName,
            });
          }
          // 确认导入成功后，自动切换到"导入成功"tab
          this.importResultActiveTab = 'success';

          this.initData();
        }
      } finally {
        this.fuzzyImportLoading = false;
      }
    },
    // 导入处理
    async handleImport() {
      if (this.importFileList.length === 0) {
        this.$message.warning("请选择要导入的文件");
        return;
      }
      const file = this.importFileList[0].raw;
      const loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        const resp = await importPotentialCustBatch(file);
        if (resp && resp.code === 200) {
          const data = resp.data || {};
          // 判断是否有错误、相似或已存在数据
          const hasSuccess = data.successCount > 0;
          const hasError = data.errorCount > 0;
          const hasFuzzy = data.fuzzyCount > 0;
          const hasSkip = data.skipCount > 0;

          if (hasError || hasFuzzy || hasSkip) {
            // 非全部成功，打开结果详情弹窗
            this.importResultData = data;
            // 设置默认激活的 tab 为第一个有数据的 tab
            if (hasSuccess) {
              this.importResultActiveTab = 'success';
            } else if (hasError) {
              this.importResultActiveTab = 'error';
            } else if (hasFuzzy) {
              this.importResultActiveTab = 'fuzzy';
            } else if (hasSkip) {
              this.importResultActiveTab = 'skip';
            }
            this.importResultDialogVisible = true;
          } else {
            // 全部成功
            const msg = `导入完成：成功 ${data.successCount || 0} 条，共 ${data.totalRows || 0} 条`;
            this.$message.success(msg);
          }

          this.importDialogVisible = false;
          this.importFileList = [];
          if (this.$refs.upload) {
            this.$refs.upload.clearFiles();
          }
          this.initData();
        }
      } catch (error) {
        console.error("导入潜在客户失败:", error);
        this.$message.error("导入失败");
      } finally {
        loading.close();
      }
    },
    async initDim() {
      try {
        // 省份
        const provinceData = window.sessionStorage.getItem("provinces");
        if (provinceData && provinceData !== "undefined" && provinceData !== "null") {
          this.provinces = JSON.parse(provinceData);
        } else {
          const resp = await postProvinces();
          if (resp) {
            this.provinces = resp;
            this.saveDictCache("provinces", resp);
          }
        }
        
        // 行业
        const industryData = window.sessionStorage.getItem("industrys");
        if (industryData && industryData !== "undefined" && industryData !== "null") {
          this.industrys = JSON.parse(industryData);
        } else {
          const resp = await getIndustryList();

          if (resp && resp.result) {

            this.industrys = resp.result;
            this.saveDictCache("industrys", resp.result);
          }
        }
        
        // 认领销售
        const managersData = window.sessionStorage.getItem("managers");
        if (managersData && managersData !== "undefined" && managersData !== "null") {
          this.managers = JSON.parse(managersData);
        } else {
          this.postRequest("/user/queryAllSales").then((resp) => {
            if (resp) {
              this.managers = resp;
              this.saveDictCache("managers", resp);
            }
          });
        }
      } catch (e) {
        this.provinces = [];
        this.industrys = [];
        this.managers = [];
        window.sessionStorage.removeItem("provinces");
        window.sessionStorage.removeItem("industrys");
        window.sessionStorage.removeItem("managers");
      }
    },
    async provinceChange(val) {
      if (val) {
        this.inputCustObj.city = null;
        this.citys = await postCitys(val);
      } else {
        this.citys = [];
        this.inputCustObj.city = null;
      }
    },
    handleIndustryTabChange() {
      this.initData();
    },
    async provinceChangeSearch(val) {
      this.page = 1; // 筛选变更：回到第 1 页
      if (val) {
        this.city = null;
        this.citys = await postCitys(val);
        this.initData();
      } else {
        this.citys = [];
        this.city = null;
        this.initData();
      }
    },
    async initData() {
      this.loading = true;
      try {
        const params = {
          page: this.page,
          limit: this.limit,
          ownerType: this.ownerType,
        };
        if (this.claimStatus !== null && this.claimStatus !== '') {
          params.claimStatus = this.claimStatus;
        }
        if (this.custName) {
          params.custName = this.custName;
        }
        if (this.selectedIndustryTab) {
          params.industry = this.selectedIndustryTab;
        }
        if (this.province) {
          params.province = this.province;
        }
        if (this.city) {
          params.city = this.city;
        }
        if (this.custManagerName) {
          params.custManagerName = this.custManagerName;
        }
        const resp = await listPotentialCust(params);
        if (resp && resp.data) {
          this.queryData = resp.data || [];
          this.total = resp.count || 0;
        }
      } catch (error) {
        console.error('获取潜在客户列表失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },
    currentChange(val) {
      this.page = val;
      this.initData();
    },
    sizeChange(val) {
      this.page = 1;
      this.limit = val;
      this.initData();
    },
    async addCust() {
      this.isEditMode = false;
      this.editingCustId = null;
      this.inputCustObj = {
        id: null,
        custName: "",
        province: "",
        city: "",
        industry: null,
        remarks: "",
      };
      this.citys = [];
      this.provinces = await postProvinces();
      this.dialogVisible = true;
    },
    async editCust(row) {
      this.isEditMode = true;
      this.editingCustId = row.id;
      this.provinces = await postProvinces();
      this.inputCustObj = {
        id: row.id,
        custName: row.custName || '',
        province: row.province || '',
        city: row.city || '',
        industry: row.industry || null,
        remarks: row.remarks || '',
      };
      if (this.inputCustObj.province) {
        this.citys = await postCitys(this.inputCustObj.province);
      }
      this.dialogVisible = true;
    },
    async handleDelete(row) {
      this.$confirm('确定要删除该潜在客户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const resp = await deletePotentialCust(row.id);
          if (resp && resp.code === 200) {
            this.$message.success('删除成功');
            this.initData();
          }
        } catch (error) {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }).catch(() => {});
    },
    doChance() {
      this.dialogVisible = false;
    },
    async doAddRecord() {
      this.$refs["inputCustForm"].validate(async (valid) => {
        if (valid) {
          try {
            let resp;
            if (this.isEditMode && this.editingCustId) {
              const params = {
                id: this.editingCustId,
                custName: this.inputCustObj.custName,
                industry: this.inputCustObj.industry,
                province: this.inputCustObj.province,
                city: this.inputCustObj.city,
                remarks: this.inputCustObj.remarks,
              };
              resp = await updatePotentialCust(params);
              if (resp && resp.code === 200) {
                this.$message.success("修改成功");
                this.dialogVisible = false;
                this.initData();
              }
            } else {
              const keyword = this.inputCustObj.custName;
              const searchResp = await fuzzySearch(keyword);
              const dataArray = searchResp && searchResp.data && Array.isArray(searchResp.data) ? searchResp.data : [];
              if (dataArray.length > 0) {
                this.currentInputCustName = keyword;
                // 按 score 排序，越接近 1 越靠前
                const sortedData = [...dataArray].sort((a, b) => {
                  return Math.abs(1 - a.score) - Math.abs(1 - b.score);
                });
                const list = sortedData.map(item => {
                  const custInfo = item.cust || item;
                  return {
                    name: custInfo.custName || custInfo.uname || custInfo.name || '',
                    score: item.score,
                    industry: custInfo.industryName || custInfo.industry || '',
                    province: custInfo.provinceName || custInfo.province || '',
                    city: custInfo.cityName || custInfo.city || '',
                    claimStatus: custInfo.claimStatus,
                    custManagerName: custInfo.custManagerName || '',
                    address: custInfo.address || ''
                  };
                });
                this.similarCustomerList = list;
                this.similarDialogVisible = true;
                return;
              }
              await this.doAddPotentialCust();
            }
          } catch (error) {
            console.error(this.isEditMode ? '修改失败' : '添加潜在客户失败:', error);
            this.$message.error(this.isEditMode ? '修改失败' : '添加失败');
          }
        } else {
          return false;
        }
      });
    },
    async doAddPotentialCust() {
      const params = {
        custName: this.inputCustObj.custName,
        industry: this.inputCustObj.industry,
        province: this.inputCustObj.province,
        city: this.inputCustObj.city,
        remarks: this.inputCustObj.remarks,
      };
      const resp = await addPotentialCust(params);
      if (resp && resp.code === 200) {
        this.$message.success("添加成功");
        this.dialogVisible = false;
        this.initData();
      }
    },
    confirmAddAfterSimilarCheck() {
      this.similarDialogVisible = false;
      this.doAddPotentialCust();
    },
    bindCust(row) {
      this.bindRowData = row;
      this.bindDialogVisible = true;
      this.searchKeyword = row.custName || "";
      this.searchResults = [];
      this.selectedResult = null;
      this.selectedIndex = -1;
      this.hasSearched = false;
      this.mapLoading = true;
      this.$nextTick(() => {
        this.initMap();
        if (this.searchKeyword) {
          setTimeout(() => {
            this.searchPlace();
          }, 500);
        }
      });
    },
    viewLocation(row) {
      this.viewLocationData = row;
      this.viewLocationDialogVisible = true;
      this.viewMapLoading = true;
      this.$nextTick(() => {
        this.initViewMap();
      });
    },
    initViewMap() {
      this.$nextTick(() => {
        const mapContainer = document.getElementById("viewLocationMap");
        if (!mapContainer) return;
        if (this.viewMapInstance) {
          this.viewMapInstance.destroy();
          this.viewMapInstance = null;
          this.viewMarkerInstance = null;
        }
        if (typeof AMap === 'undefined') {
          console.error('高德地图SDK未加载');
          this.$message.error('地图服务未加载，请检查网络连接');
          return;
        }
        this.viewMapInstance = new AMap.Map("viewLocationMap", {
          viewMode: "2D",
          zoom: 15,
          center: [this.viewLocationData.longitude, this.viewLocationData.latitude],
        });
        this.viewMarkerInstance = new AMap.Marker({
          position: [this.viewLocationData.longitude, this.viewLocationData.latitude],
          title: this.viewLocationData.custName,
        });
        this.viewMapInstance.add(this.viewMarkerInstance);
        this.viewMapInstance.on("complete", () => {
          this.viewMapLoading = false;
        });
      });
    },
    initMap() {
      this.$nextTick(() => {
        const mapContainer = document.getElementById("bindCustMap");
        if (!mapContainer) return;
        if (this.mapInstance) {
          this.mapInstance.destroy();
          this.mapInstance = null;
          this.markerInstance = null;
        }
        if (typeof AMap === 'undefined') {
          console.error('高德地图SDK未加载');
          this.$message.error('地图服务未加载，请检查网络连接');
          return;
        }
        this.mapInstance = new AMap.Map("bindCustMap", {
          viewMode: "2D",
          zoom: 12,
          center: [115.86, 28.68],
        });
        this.mapInstance.on("complete", () => {
          this.mapLoading = false;
        });
      });
    },
    searchPlace() {
      if (!this.searchKeyword.trim()) {
        this.$message.warning("请输入搜索关键词");
        return;
      }
      if (typeof AMap === 'undefined') {
        this.$message.error("地图服务未加载，请检查网络连接");
        return;
      }
      this.hasSearched = true;
      this.searchResults = [];
      this.selectedResult = null;
      this.selectedIndex = -1;

      const placeSearch = new AMap.PlaceSearch({
        pageSize: 10,
        pageIndex: 1,
        extensions: "all",
      });

      placeSearch.search(this.searchKeyword, (status, result) => {
        if (status === "complete" && result.info === "OK") {
          this.searchResults = (result.poiList.pois || []).map((item) => ({
            id: item.id,
            name: item.name,
            address: item.address || item.pname + item.cityname + item.adname,
            district: item.adname || "",
            businessArea: item.businessArea || "",
            longitude: item.location ? item.location.lng : "",
            latitude: item.location ? item.location.lat : "",
          }));
          if (this.searchResults.length > 0) {
            this.selectResult(this.searchResults[0], 0);
          }
        } else {
          this.searchResults = [];
        }
      });
    },
    selectResult(item, index) {
      this.selectedResult = item;
      this.selectedIndex = index;
      if (this.mapInstance) {
        if (this.markerInstance) {
          this.mapInstance.remove(this.markerInstance);
          this.markerInstance = null;
        }
        const lng = parseFloat(item.longitude);
        const lat = parseFloat(item.latitude);
        if (lng && lat) {
          this.markerInstance = new AMap.Marker({
            position: [lng, lat],
            title: item.name,
          });
          this.mapInstance.add(this.markerInstance);
          this.mapInstance.setZoomAndCenter(15, [lng, lat]);
        }
      }
    },
    confirmBind() {
      if (!this.selectedResult) return;
      this.$confirm(
        `确认将 "${this.selectedResult.address}" 认领为客户的地址吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(async () => {
        try {
          const resp = await bindPotentialCust({
            id: this.bindRowData.id,
            address: this.selectedResult.address,
            longitude: this.selectedResult.longitude,
            latitude: this.selectedResult.latitude,
          });
          if (resp && resp.code === 200) {
            this.$message.success("认领成功");
            this.bindDialogVisible = false;
            this.initData();
          }
        } catch (error) {
          console.error("认领客户失败:", error);
          this.$message.error("认领失败");
        }
      }).catch(() => {});
    },
    claimCust(row) {
      this.claimData.claimCustName = row.custName || row.id || '';
      this.claimData.claimReason = '';
      this.claimCustId = row.id;
      this.claimDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.claimForm) {
          this.$refs.claimForm.clearValidate();
        }
      });
    },
    resetClaimForm() {
      this.claimData.claimReason = '';
      this.claimCustId = null;
      this.claimSubmitting = false;
      if (this.$refs.claimForm) {
        this.$refs.claimForm.clearValidate();
      }
    },
    submitClaim() {
      this.$refs.claimForm.validate(async (valid) => {
        if (!valid) return;
        this.claimSubmitting = true;
        try {
          const resp = await claimPotentialCust(this.claimCustId, this.claimData.claimReason);
          if (resp && resp.code === 200) {
            this.$message.success('认领成功');
            this.claimDialogVisible = false;
            this.initData();
          }
        } catch (error) {
          console.error('认领潜在客户失败:', error);
          this.$message.error('认领失败');
        } finally {
          this.claimSubmitting = false;
        }
      });
    },
    openUnbindDialog(row) {
      this.$confirm('确定释放该客户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const resp = await releasePotentialCust(row.id);
          if (resp && resp.code === 200) {
            this.$message.success('释放成功');
            this.initData();
          } else {
            this.$message.error(resp.msg || '释放客户失败');
          }
        } catch (error) {
          console.error('释放客户失败:', error);
          this.$message.error('释放客户失败: ' + (error.message || '未知错误'));
        }
      }).catch(() => {
        this.$message.info('已取消释放');
      });
    },
    exportToExcel() {
      if (!this.queryData || this.queryData.length === 0) {
        this.$message.warning("没有可导出的数据");
        return;
      }
      const tHeader = ["客户名称", "所属行业", "省份", "地市", "状态", "认领销售", "认领时间", "备注"];
      const filterVal = ["custName", "industryName", "provinceName", "cityName", "claimStatusText", "custManagerName", "createTime", "remarks"];
      const list = this.queryData.map(item => {
        let claimStatusText = "-";
        if (item.latitude && item.longitude) {
          claimStatusText = "已认领";
        } else if (item.custManagerId) {
          claimStatusText = "已认领";
        } else {
          claimStatusText = "未认领";
        }
        return {
          custName: item.custName || "-",
          industryName: item.industryName || "-",
          provinceName: item.provinceName || "-",
          cityName: item.cityName || "-",
          custManagerName: item.custManagerName === "未认领" ? "-" : (item.custManagerName || "-"),
          claimStatusText,
          createTime: item.createTime || "-",
          remarks: item.remarks || "-"
        };
      });
      const data = list.map(v => filterVal.map(j => v[j]));
      const ws = XLSX.utils.aoa_to_sheet([tHeader, ...data]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "潜在客户数据");

      const defaultStyle = {
        alignment: {
          horizontal: "center",
          vertical: "center",
          wrapText: true,
        },
        font: {
          sz: 12,
          name: "宋体",
        },
        border: {
          top: { style: "thin", color: { auto: 1 } },
          left: { style: "thin", color: { auto: 1 } },
          right: { style: "thin", color: { auto: 1 } },
          bottom: { style: "thin", color: { auto: 1 } },
        },
      };

      const headerStyle = {
        ...defaultStyle,
        font: { ...defaultStyle.font, bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "2D529F" } },
      };

      const cellStyle = {
        ...defaultStyle,
        font: { ...defaultStyle.font, bold: false },
      };

      ws["!cols"] = [
        { wpx: 150 },
        { wpx: 100 },
        { wpx: 80 },
        { wpx: 80 },
        { wpx: 100 },
        { wpx: 80 },
        { wpx: 150 },
        { wpx: 150 }
      ];

      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellAddress]) continue;
          ws[cellAddress].s = R === 0 ? headerStyle : cellStyle;
        }
      }

      const wbout = XLSXStyle.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "buffer",
      });
      FileSaver.saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "潜在客户数据导出.xlsx"
      );
      this.$message.success("导出成功");
    },
  },
};
</script>
<style lang="scss" scoped>
.industry-tabs {
  ::v-deep .el-radio-button__inner {
    border-radius: 0;
    border-left: 1px solid #dcdfe6;
  }
  ::v-deep .el-radio-button:first-child .el-radio-button__inner {
    border-radius: 4px 0 0 4px;
  }
  ::v-deep .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0 4px 4px 0;
  }
}

.potential-dialog {
  .el-dialog__body {
    padding: 20px;
  }

  .dialog-footer {
    text-align: right;
    padding: 12px 20px;
    border-top: 1px solid #e8e8e8;
    margin-top: 10px;
  }
}

.bind-cust-dialog {
  ::v-deep .el-dialog__body {
    padding: 10px 20px;
  }

  .bind-search-bar {
    margin-bottom: 10px;

    .bind-hint {
      color: #909399;
      font-size: $font-size-base;
    }
  }

  .bind-search-row {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .bind-main {
    display: flex;
    gap: 15px;
    height: 600px;

    .bind-results {
      width: 380px;
      min-width: 380px;
      display: flex;
      flex-direction: column;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      overflow: hidden;

      .bind-results-header {
        padding: 12px 15px;
        font-weight: bold;
        font-size: 14px;
        color: #303133;
        background: #f5f7fa;
        border-bottom: 1px solid #e4e7ed;
      }

      .bind-results-list {
        flex: 1;
        overflow-y: auto;

        .bind-result-item {
          padding: 12px 15px;
          cursor: pointer;
          border-bottom: 1px solid #f0f0f0;
          transition: background 0.2s;

          &:hover {
            background: #f5f7fa;
          }

          &.active {
            background: #ecf5ff;
            border-left: 3px solid #409eff;
          }

          .result-name {
            font-size: 14px;
            color: #303133;
            font-weight: 500;
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .result-address {
            font-size: $font-size-base;
            color: #909399;
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .result-location {
            font-size: $font-size-base;
            color: #c0c4cc;

            i {
              margin-right: 3px;
            }
          }
        }

        .empty-tip {
          text-align: center;
          padding: 40px 20px;
          color: #c0c4cc;
          font-size: 14px;
        }
      }
    }

    .bind-map-area {
      flex: 1;
      display: flex;
      flex-direction: column;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      overflow: hidden;

      .map-info-bar {
        padding: 12px 15px;
        font-weight: bold;
        font-size: 14px;
        color: #303133;
        background: #f5f7fa;
        border-bottom: 1px solid #e4e7ed;
      }

      .amap-container {
        flex: 1;
        min-height: 350px;
        position: relative;

        .map-loading {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: rgba(255, 255, 255, 0.9);
          z-index: 10;
          color: #409eff;

          i {
            font-size: 32px;
            margin-bottom: 10px;
          }

          span {
            font-size: 14px;
          }
        }
      }

      .selected-info {
        padding: 12px 15px;
        background: #fff;
        border-top: 1px solid #e4e7ed;

        .selected-name {
          font-size: 14px;
          font-weight: 500;
          color: #303133;
          margin-bottom: 4px;
        }

        .selected-address {
          font-size: $font-size-base;
          color: #909399;
          margin-bottom: 4px;
        }

        .selected-coords {
          font-size: $font-size-base;
          color: #c0c4cc;
        }
      }
    }
  }

  .dialog-footer {
    text-align: right;
    padding: 12px 0;
    margin-top: 10px;
  }
}
.view-location-dialog {
  .location-info {
    padding: 12px 15px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 15px;

    .location-name {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 8px;
    }

    .location-address {
      font-size: 14px;
      color: #606266;
      margin-bottom: 4px;
    }

    .location-coords {
      font-size: $font-size-base;
      color: #909399;
    }
  }

  .view-map-container {
    width: 100%;
    height: 450px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    position: relative;

    .map-loading {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.9);
      z-index: 10;
      color: #409eff;

      i {
        font-size: 32px;
        margin-bottom: 10px;
      }

      span {
        font-size: 14px;
      }
    }
  }
}

.industry-enterprise,
.industry-government,
.industry-education,
.industry-finance,
.industry-medical,
.industry-personal,
.industry-partner,
.industry-other {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: $font-size-base;
  font-weight: 500;
}

.industry-enterprise {
  background-color: #fff7e6;
  color: #fa8c16;
}

.industry-government {
  background-color: #e6f7ff;
  color: #1890ff;
}

.industry-education {
  background-color: #f6ffed;
  color: #52c41a;
}

.industry-finance {
  background-color: #fff0f6;
  color: #eb2f96;
}

.industry-medical {
  background-color: #e6fffb;
  color: #13c2c2;
}

.industry-personal {
  background-color: #f9f0ff;
  color: #722ed1;
}

.industry-partner {
  background-color: #fff7e6;
  color: #fa8c16;
}

.industry-other {
  background-color: #f0f0f0;
  color: #8c8c8c;
}

.import-result-dialog {
  .import-result-summary {
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 12px 16px;
    background-color: #f5f7fa;
    border-radius: 6px;
    margin-bottom: 14px;

    .summary-success {
      color: #67c23a;
      font-size: 14px;

      i { margin-right: 4px; }
      strong { font-size: 18px; }
    }

    .summary-fail {
      color: #f56c6c;
      font-size: 14px;

      i { margin-right: 4px; }
      strong { font-size: 18px; }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 15px 20px;
  }

  .dialog-footer {
    text-align: right;
    padding: 12px 0;
    margin-top: 10px;
  }
}
</style>
